module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/U4zBN6/tc-custom/9781460380703.jpg?1744286943963",
      "alt": "This image is the cover for the book Running Fire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Running Fire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A wounded pilot finds refuge in the arms of a brave officer in the "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author’s “rip-roaring contemporary military romance” ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(", starred review).")]), _c('br'), _c('br'), _vm._v("Temporarily assigned to the Shadow Squadron in a troubled region of Afghanistan, Chief Warrant Officer and pilot Leah Mackenzie is no stranger to combat—even if most of her physical and emotional scars are courtesy of her vicious ex. Still, she’s got a bad feeling about picking up a team of stranded SEALs. A feeling that’s all too justified once enemy fire hits their helicopter . . . "), _c('br'), _c('br'), _vm._v("SEAL Kell Ballard’s goal was to get the injured pilot out of harm’s way and find shelter deep in a labyrinth of caves. It’s a place of dark intimacy, where Leah finds unexpected safety in a man’s arms. Where prohibited attraction burns brightly. And where they’ll hide until the time comes to face the enemy outside . . . and the enemy within their ranks.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lindsay McKenna\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A U.S. Navy veteran, she was a meteorologist while serving her country. She pioneered the military romance in 1993 with Captive of Fate, Silhouette Special edition.  Her heart and focus is on honoring and showing our military men and women.  Creator of the Wyoming Series and Shadow Warriors series for HQN, she writes emotionally and romantically intense suspense stories. Visit her online at "), _c('a', {
    attrs: {
      "href": "http://www.LindsayMcKenna.com"
    }
  }, [_vm._v("www.LindsayMcKenna.com")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0